(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/views/parts/overview-button.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/views/parts/overview-button.js');
"use strict";

const {
  useContext
} = React;
const {
  ReactButton,
  ReactIcon
} = svs.ui;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const OverviewButton = () => {
  const {
    toggleOverview
  } = useContext(BetslipContext);
  return React.createElement(ReactButton, {
    "aria-label": "Visa \xF6versikt",
    className: "overview-button",
    "data-testid": "toggle-overview",
    inverted: true,
    onClick: toggleOverview,
    transparent: true
  }, React.createElement(ReactIcon, {
    color: "white",
    icon: "overview"
  }));
};
setGlobal('svs.components.tipsen.betslip.views.parts.OverviewButton', OverviewButton);

 })(window);